<template>
    <v-main>
        <v-container fluid>
            <v-card elevation="1">
                <v-card-title class="mt-4">
                    <v-btn class="mr-2" fab x-small color="#6c5dd4" dark @click="$router.back()">
                        <v-icon> mdi-arrow-left </v-icon> </v-btn>Create admin
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col sm="4">
                            <label for="">Name * </label>
                            <vs-input primary v-model="form.name" placeholder="Enter a name" icon-after block>
                                <template #icon>
                                    <i class='mdi mdi-face-man'></i>
                                </template>

                                <template #message-danger>
                                    {{ errors && errors.name ? errors.name : '' }}
                                </template>
                            </vs-input>
                        </v-col>
                        <v-col sm="4">
                            <label for="">Mobile no * </label>
                            <vs-input primary v-model="form.phone" placeholder="Enter a mobile no." icon-after block>

                                <template #icon>
                                    <i class='mdi mdi-phone'></i>
                                </template>

                                <template #message-danger>
                                    {{ errors && errors.phone ? errors.phone : '' }}
                                </template>
                            </vs-input>
                        </v-col>
                        <v-col sm="4">
                            <label for="">Mobile no * </label>
                            <vs-input primary v-model="form.email" placeholder="Email " icon-after block>

                                <template #icon>
                                    <i class='mdi mdi-email'></i>
                                </template>

                                <template #message-danger>
                                    {{ errors && errors.email ? errors.email : '' }}
                                </template>
                            </vs-input>
                        </v-col>
                        <v-col sm="4">
                            <v-autocomplete v-model="form.company_id" :items="Companies" label="Select Company"
                                prepend-icon="mdi-city" :error-messages="errors.company_id"></v-autocomplete>
                        </v-col>
                        <v-col sm="4">
                            <v-switch v-model="form.active" inset :label="`Is Active: ${form.active == true ? 'YES' : 'NO'
                        }`"></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-divider class="mt-5 mb-5"> </v-divider>
                            <v-btn class="float-right" :loading="isLoading" color="#6c5dd4" :dark="isLoading != true"
                                :disabled="isLoading" @click="save"> Save
                                Admin
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </v-main>
</template>

<script>
import axios from "axios";
export default {
    name: "UserCreatePage",
    data() {
        return {
            form: {
                active: true,
            },
            Companies: [],
            isLoading: false,
            selectedCompanyId: null,
            errors: {}
        };
    },
    mounted() {
        this.getMasters();
    },
    methods: {
        async getMasters() {
            let masters = await axios.get(`users/masters`);
            masters = masters.data;
            // companies
            masters.companies.forEach((company) => {
                this.Companies.push({
                    id: company.id,
                    text: company.name,
                    value: company.id,
                })
            });
        },
        async save() {
            try {
                this.isLoading = true;
                this.form.role_id = 2;
                await axios.post("/users", this.form);
                this.$router.push('/admins');
            } catch (error) {
                if (error.response && error.response.data && error.response.data.errors) {
                    this.errors = error.response.data.errors;
                } else {
                    console.error("Error saving admin:", error);
                }
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>